import { ContainerModule } from '@patsnap/tahiti-core/shared/inversify';
import { HomeOnBoardingServiceImpl } from '@/domains/onboarding/services/home-onboarding-service';
import { HomeOnBoardingService } from './services/home-onboarding-service.interface';
import { OnboardingApiImpl } from '@/domains/onboarding/repositorys/apis/onboarding-api';
import { OnBoardingRepository } from './repositorys/onboarding-repository.interface';
import { OnBoardingRepositoryImpl } from './repositorys/onboarding-repository';
import { OnboardingApi } from './repositorys/apis/onboarding-api.interface';
import { OnboardingModel } from './models/onboarding-model.interface';
import { OnboardingModelImpl } from './models/onboarding-model';
export const onboarding = new ContainerModule(bind => {
    bind(HomeOnBoardingService).to(HomeOnBoardingServiceImpl);
    bind(OnBoardingRepository).to(OnBoardingRepositoryImpl);
    bind(OnboardingApi).to(OnboardingApiImpl);
    bind(OnboardingModel).to(OnboardingModelImpl);
});
